var React = require('react');

function SymbolInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#44a3da;}")),React.createElement("g",{"id":"レイヤー_2","data-name":"レイヤー 2","key":1},React.createElement("g",{"id":"レイヤー_1-2","data-name":"レイヤー 1"},React.createElement("polygon",{"className":"cls-1","points":"703.33 37.24 37.24 37.24 0 0 666.09 0 703.33 37.24"})))]);
}

SymbolInline.defaultProps = {"viewBox":"0 0 703.33 37.24"};

module.exports = SymbolInline;

SymbolInline.default = SymbolInline;
